<template>
  <svgicon
    :style="style"
    class="micon"
    :name="name"
    :width="width"
    :height="height"
  ></svgicon>
</template>

<script>
export default {
  name: "MIcon",

  props: {
    name: { type: String, required: true },
    width: { type: String },
    height: { type: String },
    preload: { type: Array, default: () => [] },
    color: { type: String },
    padding: { type: String },
  },

  computed: {
    style() {
      if (!this.color) {
        return;
      }

      return { fill: this.color, padding: this.padding };
    },
  },

  created() {
    // BUG-Z2V55Y (Federico, 2026-06-25): el import dinámico de iconos sin
    // .catch() generaba unhandled promise rejections cuando se referenciaba
    // un icono inexistente (ej. "event_busy" o "calendar_month" que no
    // están en src/assets/icons/). En Vue 2 esa rejection podía romper
    // componentes padres en cascada — Federico veía la atención dejar de
    // responder al intentar adjuntar archivos. Con .catch() degradamos
    // gracefully: el SVG queda vacío pero el resto de la UI sigue OK.
    this.preload.concat(this.name).forEach((name) => {
      import(/* webpackChunkName: "icon-[request]" */ "../icons/" + name).catch(
        // eslint-disable-next-line no-console
        (err) =>
          console.warn(
            `[MIcon] icono "${name}" no existe en src/assets/icons/. ` +
              `Verificá con /list-icons o sumá el SVG. (${err.message})`
          )
      );
    });
  },
};
</script>

<style lang="scss" scoped>
.svg-icon {
  display: inline-block;
  width: 23px;
  height: 23px;
  color: inherit;
  vertical-align: middle;
  fill: none;
  stroke: $primary;
}

.svg-fill {
  fill: $primary;
  stroke: none;
}

.svg-right {
  transform: rotate(90deg);
}

.svg-down {
  transform: rotate(180deg);
}

.svg-left {
  transform: rotate(-90deg);
}
</style>
